<template>
  <section>
    <v-menu
      v-model="menuStatus"
      bottom
      left
      max-width="460px"
      nudge-bottom="30px"
      nudge-right="10px"
      :disabled="messages === 0"
    >
      <template v-slot:activator="{ on, attrs }">
        <section v-bind="attrs" v-on="on" :class="menuClass">
          <v-badge
            class="animate__animated animate__pulse animate__infinite infinite"
            :value="messages"
            :disabled="messages === 0"
            color="error"
            overlap
            dot
          >
            <v-icon :disabled="messages === 0" size="24">
              mdi-bell-outline
            </v-icon>
          </v-badge>
        </section>
      </template>

      <v-card class="card__notification">
        <section class="card__notification__contain">
          <section class="header">
            <section class="header__content">
              <span>Notificações</span>
              <small
                >Você tem {{ schedules }}
                {{ schedules === 1 ? "notificação" : "notificações" }}</small
              >
            </section>

            <button @click="fetchNotifications">Atualizar</button>
          </section>

          <section class="body">
            <section
              class="body__content"
              v-for="(item, index) in notifications"
              :key="index"
              @click="setFilters(item)"
            >
              <v-icon color="#FF9800" v-if="item?.data_expiracao"
                >mdi-file-alert-outline
              </v-icon>
              <v-icon color="#E53935" v-else-if="item?.schedule_data_end"
                >mdi-account-alert-outline</v-icon
              >
              <v-icon color="#9C27B0" v-else>mdi-account-alert-outline</v-icon>

              <section class="content__body">
                <span v-if="item?.data_expiracao">
                  A solicitação <b>{{ item.code }}</b
                  >, irá expirar no dia <b>{{ formattedDate(item) }}</b
                  >. Verifique a viabilidade de regulação para que ela não
                  retorne ao status aberta
                </span>
                <span v-else>
                  {{
                    item?.schedule_data_end
                      ? "Agenda expirada"
                      : "Paciente desatualizado"
                  }}
                  —
                  {{ formattedDate(item) }}</span
                >

                <small> {{ item.name }} </small>
              </section>
            </section>
          </section>

          <small class="footer">
            Última atualização: {{ actualDateHour }}
          </small>
        </section>
      </v-card>
    </v-menu>
  </section>
</template>

<script>
import { getNotifications } from "@/services/reports";
import { getConnectedUser } from "@/utils/localStorage";
import moment from "moment";
import { mapActions } from "vuex";

export default {
  name: "NavbarNotificationComponent",

  data: () => ({
    messages: 0,
    menuStatus: false,
    schedules: 0,
    userData: {},
    timer: "",
    actualDateHour: "",
    notifications: [],
    menuClass: "",
  }),

  computed: {
    isExpired() {
      const { profile_id } = getConnectedUser();
      return profile_id === "1" || profile_id === "3"; // Perfis: Administrador ou Executante
    },

    isOutdated() {
      const { profile_id } = getConnectedUser();
      return profile_id === "1" || profile_id === "4"; // Perfis: Administrador ou Solicitante
    },

    isSolicitationsEvaluated() {
      const { profile_id } = getConnectedUser();
      return ["1", "2", "3", "6", "8", "9"].includes(profile_id); // Perfis: (1) Administrador, (2) Avaliador, (3) Executante, (6) Regulador/Avaliador, (8) Executante/ADM e (9) Regulador;
    },
  },

  created() {
    if (this.isExpired || this.isOutdated) {
      this.fetchNotifications();
      this.timer = setInterval(this.fetchNotifications, 300000);
    }
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    ...mapActions([
      "changeRegulatedPatientsFilters",
      "changePatientsFilters",
      "changeSolicitationsFilters",
    ]),

    async fetchNotifications() {
      this.menuClass = undefined;
      this.notifications = [];

      let totalNotifications = 0;
      const date = moment();
      this.actualDateHour = moment(date).format("DD/MM/YYYY [às] HH:mm:ss");

      const { response } = await getNotifications();

      if (this.isExpired) {
        this.notifications.push(...response.alertsExpiredVacancies);
        totalNotifications =
          totalNotifications + response.alertsExpiredVacancies.length;
      }

      if (this.isOutdated) {
        this.notifications.push(...response.alertsPatientIsOutdated);
        totalNotifications =
          totalNotifications + response.alertsPatientIsOutdated.length;
      }

      if (this.isSolicitationsEvaluated) {
        this.notifications.push(...response.alertsSolicitationsEvaluated);
        totalNotifications =
          totalNotifications + response.alertsSolicitationsEvaluated.length;
      }

      this.messages = totalNotifications > 0 ? totalNotifications : 0;
      this.menuClass =
        totalNotifications > 0
          ? "animate__animated animate__wobble"
          : undefined;
      this.schedules = totalNotifications;
    },

    formattedDate(item) {
      if (item?.data_expiracao) {
        return moment(item.data_expiracao).format("DD.MM.YYYY • HH:mm:ss ");
      } else if (item?.schedule_data_end) {
        return moment(item.schedule_data_end).format("DD.MM.YYYY • HH:mm:ss ");
      }

      return moment(item.updated_at).format("DD.MM.YYYY • HH:mm:ss ");
    },

    setFilters(item) {
      const isExpiredSchedule = item?.schedule_data_end;
      const actualPath = this.$route.fullPath;
      let path;

      if (isExpiredSchedule) {
        this.changeRegulatedPatientsFilters({
          id: item.solicitation_id,
          name: item.name,
          solicitacion_statuse_id: 3,
          schedule_unity: this.userData.unity_id,
          expired_patients: "SIM",
          type_schedules_id: "",
          procedure_type_id: "",
          group_procedure_id: "",
          co_procedimento: "",
          co_ocupacao: "",
          co_sub_occupation: "",
          risk_id: "",
          regulatory_date: "",
          code: "",
          cns: "",
          cpf: "",
          county: "",
          health_region: "",
          macroregion: "",
          district: "",
        });

        path = "/pacientes-regulados";
      } else if (item?.data_expiracao) {
        this.changeSolicitationsFilters({
          code: item.code,
          name: "",
          cpf: "",
          cns: "",
          date: [],
          solicitacion_statuse_id: "",
          status: [],
          unity_id: this.userData.unity_id,
          screen: "open_evaluation",
          county: "",
          health_region: "",
          macroregion: "",
          district: "",
          executant: false,
          is_judicial: "",
          judicial_decision_id: "",
          solicitation_open_rejecteds: "",
          with_order_numeric: "",
          modifiers: [],
          age_range: "",
        });

        path = "/solicitacoes";
      } else {
        this.changePatientsFilters({
          name: item.name,
          cpf: item.cpf,
        });

        path = "/pacientes";
      }

      if (actualPath !== path) {
        this.$router.push({ path: path });
      } else if (actualPath !== "/solicitacoes") {
        this.$snackbar.setParams(
          "warning",
          this.$t("messages.warning"),
          isExpiredSchedule
            ? this.$t("messages.in_regulated_patients_page")
            : this.$t("messages.in_patients")
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.card__notification {
  padding: 12px;

  .card__notification__contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;

      .header__content {
        display: flex;
        flex-direction: column;

        span {
          font-size: 14px;
          font-weight: 600;
        }

        small {
          font-size: 12px;
        }
      }

      button {
        font-size: 12px;
      }
    }

    .body {
      display: flex;
      flex-direction: column;
      gap: 6px;
      max-height: 400px;
      overflow-y: auto;

      .body__content {
        display: flex;
        align-items: center;
        gap: 12px;

        border-radius: 12px;
        background: #fafafa;
        padding: 8px;
        cursor: pointer;

        &:hover {
          background: #f3f3f3;
        }

        .content__body {
          display: flex;
          flex-direction: column;

          span {
            font-size: 12px;
            font-weight: 500;
          }

          small {
            font-size: 12px;
          }
        }
      }
    }

    .footer {
      font-size: 10px;
    }
  }
}
</style>
